module.exports = __webpack_public_path__ + "img/denti_i_logo_yeosu.67b6bb4e.png";